export const colors = {
  primary: "#6D28D9",
  primaryDark: "#5B21B6",
  primaryLight: "#7C3AED",

  // Confidence levels
  confidenceHigh: "#10B981",
  confidenceMedium: "#F59E0B",
  confidenceLow: "#EF4444",

  // Backgrounds
  bgPrimary: "#F8FAFC",
  bgCard: "#FFFFFF",
  bgColumnHeader: "#FFFFFF",

  // Text
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  textMuted: "#94A3B8",

  // Borders
  border: "#E2E8F0",
  borderLight: "#F1F5F9",

  // Status colors
  statusNew: "#3B82F6",
  statusContacted: "#F59E0B",
  statusQualified: "#8B5CF6",
  statusInterested: "#10B981",
  statusScheduled: "#EC4899",

  // Service badges
  serviceBlue: "#DBEAFE",
  serviceBlueText: "#1E40AF",
  serviceOrange: "#FED7AA",
  serviceOrangeText: "#C2410C",
  servicePurple: "#E9D5FF",
  servicePurpleText: "#7C3AED",
  serviceGreen: "#D1FAE5",
  serviceGreenText: "#065F46",
  servicePink: "#FCE7F3",
  servicePinkText: "#BE185D",
};

export const shadows = {
  card: "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.06)",
  cardHover: "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
  column: "0 1px 3px rgba(0, 0, 0, 0.1)",
  dragging: "0 10px 30px rgba(0, 0, 0, 0.2)",
};

export const getServiceStyles = (service) => {
  const serviceMap = {
    "Skin Care": { bg: colors.serviceBlue, color: colors.serviceBlueText },
    "Dermatology": { bg: colors.serviceOrange, color: colors.serviceOrangeText },
    "Facial Aesthetic": { bg: colors.servicePurple, color: colors.servicePurpleText },
    "Wellness Plan": { bg: colors.serviceGreen, color: colors.serviceGreenText },
    "Teeth Whitening": { bg: colors.servicePink, color: colors.servicePinkText },
    "Therapy": { bg: colors.serviceBlue, color: colors.serviceBlueText },
  };

  return serviceMap[service] || { bg: colors.borderLight, color: colors.textMuted };
};

export const getConfidenceColor = (level) => {
  const levelMap = {
    high: colors.confidenceHigh,
    medium: colors.confidenceMedium,
    low: colors.confidenceLow,
  };

  return levelMap[level?.toLowerCase()] || colors.confidenceLow;
};

export const getSourceBadgeStyles = (source) => {
  const sourceMap = {
    FB: { bg: "#1877F2", color: "#FFFFFF" },
    Google: { bg: "#EA4335", color: "#FFFFFF" },
    IG: { bg: "#E4405F", color: "#FFFFFF" },
    Referral: { bg: "#10B981", color: "#FFFFFF" },
  };

  return sourceMap[source] || { bg: colors.textMuted, color: "#FFFFFF" };
};
